import * as React from 'react';
import { bemComponent } from '@99designs/frontend-components/utils/app';

interface Props {
    variations?: string[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
}

interface CardInterface extends React.ForwardRefExoticComponent<Props> {
    Block: React.ComponentType<Props>;
    Media: React.ComponentType<Props>;
    Header: React.ComponentType<Props>;
    Icon: React.ComponentType<Props>;
}

/**
 * @deprecated Use Card from `@99designs/emu` instead
 */
export const Card = bemComponent('card', 'Card') as CardInterface;

Card.Block = bemComponent('card__block', 'Card.Block');
Card.Media = bemComponent('card__media', 'Card.Media');
Card.Header = bemComponent('card__header', 'Card.Header');
Card.Icon = bemComponent('card__icon', 'Card.Icon');
